import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 750 750",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "surface1",
		children: [/* @__PURE__ */ _jsx("rect", {
			x: 0,
			y: 0,
			width: 750,
			height: 750,
			style: {
				fill: "rgb(100%,100%,100%)",
				fillOpacity: 1,
				stroke: "none"
			}
		}), /* @__PURE__ */ _jsx("path", {
			style: {
				stroke: "none",
				fillRule: "nonzero",
				fill: "rgb(27.058824%,27.058824%,27.058824%)",
				fillOpacity: 1
			},
			d: "M 549.160156 404.234375 C 552.898438 400.394531 555.867188 395.835938 557.886719 390.820312 C 559.910156 385.804688 560.953125 380.429688 560.953125 375 C 560.953125 369.570312 559.910156 364.191406 557.886719 359.175781 C 555.867188 354.160156 552.898438 349.601562 549.160156 345.765625 L 257.714844 46.195312 C 250.171875 38.445312 239.941406 34.089844 229.273438 34.089844 C 218.605469 34.089844 208.375 38.445312 200.832031 46.195312 C 193.289062 53.949219 189.050781 64.464844 189.050781 75.429688 C 189.050781 86.394531 193.289062 96.910156 200.832031 104.664062 L 463.839844 375 L 200.832031 645.332031 C 197.097656 649.171875 194.132812 653.730469 192.113281 658.746094 C 190.089844 663.761719 189.050781 669.136719 189.050781 674.566406 C 189.050781 679.996094 190.089844 685.371094 192.113281 690.386719 C 194.132812 695.402344 197.097656 699.960938 200.832031 703.800781 C 204.566406 707.640625 209 710.683594 213.878906 712.761719 C 218.761719 714.839844 223.988281 715.910156 229.273438 715.910156 C 234.554688 715.910156 239.785156 714.839844 244.664062 712.761719 C 249.542969 710.683594 253.980469 707.640625 257.714844 703.800781 Z M 549.160156 404.234375 "
		})]
	})
});
export default SvgArrowRight;
